import React from "react";
import styled from "styled-components/macro";
import { Label } from "./Label";
import { t } from "../../utils/intl";
import { InvalidMessage } from "./styled";

export interface IInputProps {
  isInvalid?: boolean;
  onBlurInternal?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement> & (() => void);
  value?: any;
  placeholderValue?: string;
  id: string;
  innerRef?: any;
  onBlur?: (value: string) => void;
  onChange: (value: string) => void;
  rowNumber?: number;
  labelTrKey?: string;
  isInvalidMessage?: string;
  allowedSignsRegex?: string;
  parseValue?: (value: string) => string;
}

const Input: React.FC<IInputProps> = props => {
  const {
    isInvalid,
    onFocus,
    value,
    id,
    labelTrKey,
    rowNumber,
    isInvalidMessage,
    innerRef,
    placeholderValue,
    onChange,
    onBlurInternal,
    onBlur,
    parseValue,
    allowedSignsRegex
  } = props;

  const passedOnBlur = onBlurInternal
    ? onBlurInternal
    : (e: React.FocusEvent<HTMLInputElement>) => onBlur && onBlur(e.target.value);

  const preparedRegex = allowedSignsRegex && new RegExp(allowedSignsRegex, "u");

  return (
    <Wrapper>
      <Label rowNumber={rowNumber} labelTrKey={labelTrKey} />
      <StyledInput
        autoComplete="off"
        id={id}
        ref={innerRef}
        onChange={e => {
          if (!preparedRegex || preparedRegex.test(e.target.value)) {
            onChange(parseValue ? parseValue(e.target.value) : e.target.value);
          }
        }}
        onFocus={onFocus}
        onBlur={passedOnBlur}
        value={value}
        placeholder={placeholderValue ? placeholderValue : t(`form.typeAmount`)}
        isInvalid={isInvalid}
      />
      {isInvalid && isInvalidMessage && <InvalidMessage>{t(isInvalidMessage)}</InvalidMessage>}
    </Wrapper>
  );
};

export default Input;

const Wrapper = styled.div`
  position: relative;
  page-break-inside: avoid;
  margin: 60px 0;
`;

const StyledInput = styled.input<{
  isInvalid?: boolean;
}>`
  height: 52px;
  width: 100%;
  outline: none;
  background: ${({ theme }) => theme.colors.white};
  padding: 0 12px;
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  -webkit-text-fill-color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.gray};

  &::placeholder {
    color: ${({ theme }) => theme.colors.black};
    -webkit-text-fill-color: ${({ theme }) => theme.colors.textGray};
    opacity: 1;
  }
  &:hover {
    border: 2px solid ${({ theme }) => theme.colors.blue};
  }
  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.blue};
  }
  ${({ isInvalid, theme }) => isInvalid && `border-color: ${theme.colors.red};`}

  &:after {
    content: "";
    display: block;
  }
`;
